import { GaugeProps } from '../Gauge';

export class GaugePropertyValidator {
   private static colorMatchRegExp = /#([a-f]|[A-F]|[0-9]){3}(([a-f]|[A-F]|[0-9]){3})?\b/;
   private static ERROR_AMOUNT = 0.000015; // This works for 0.99999 = 99.999%

   static validate = (props: GaugeProps) => {
      GaugePropertyValidator.areColorsOrColorPercentagesEmpty(props.id, props.colors, props.colorPercentages);
      GaugePropertyValidator.isEqualNumberOfColorsAndColorPercentages(props.id, props.colors, props.colorPercentages);
      GaugePropertyValidator.doColorPercentagesSumToOne(props.id, props.colorPercentages);
      GaugePropertyValidator.areAllColorBasedPropsValidColorValues(props);
   };

   private static areColorsOrColorPercentagesEmpty = (id: string, colors: string[], colorPercentages: number[]): void => {
      if (colors.length === 0 || colorPercentages.length === 0) {
         throw new Error(`${id} - color prop or colorPercentages prop can not be an empty array!`);
      }
   };

   private static isEqualNumberOfColorsAndColorPercentages = (id: string, colors: string[], colorPercentages: number[]): void => {
      if (colors.length !== colorPercentages.length) {
         throw new Error(`${id} - Number of colors and color percentages has to be equal!`);
      }
   };

   private static doColorPercentagesSumToOne = (id: string, colorPercentages: number[]): void => {
      let sumWithElementsMultipliedByTenForEach = 0;

      colorPercentages.map((colorPercentage: number): void => {
         sumWithElementsMultipliedByTenForEach += (colorPercentage * 10);
      });

      if (Math.abs(1 - sumWithElementsMultipliedByTenForEach / 10) > GaugePropertyValidator.ERROR_AMOUNT) {
         throw new Error(`${id} - Color percentages should sum to 1!`);
      }
   };

   private static areAllColorBasedPropsValidColorValues = (props: GaugeProps): void => {
      const id: string = props.id;
      const centerBackgroundColor: string | undefined = props.centerBackgroundColor;
      const centerLabelColor: string | undefined = props.centerLabelColor;
      const labelsColor: string | undefined = props.labelsColor;

      if (centerBackgroundColor && !GaugePropertyValidator.colorMatchRegExp.test(centerBackgroundColor)) {
         throw new Error(GaugePropertyValidator.invalidColorMessage(id, centerBackgroundColor, 'centerBackgroundColor'));
      }

      if (centerLabelColor && !GaugePropertyValidator.colorMatchRegExp.test(centerLabelColor)) {
         throw new Error(GaugePropertyValidator.invalidColorMessage(id, centerLabelColor, 'centerLabelColor'));
      }

      if (labelsColor && !GaugePropertyValidator.colorMatchRegExp.test(labelsColor)) {
         throw new Error(GaugePropertyValidator.invalidColorMessage(id, labelsColor, 'labelsColor'));
      }

      props.colors.map((color: string): void => {
         if (!GaugePropertyValidator.colorMatchRegExp.test(color)) {
            throw new Error(GaugePropertyValidator.invalidColorMessage(id, color, 'colors'));
         }
      });
   };

   private static invalidColorMessage = (id: string, color: string, colorCategory: string): string => {
      return `${id} - ${color} is not valid color for ${colorCategory} prop!`;
   };
}
